export const SET_CART_MESSAGE = "CART/SET_CART_MESSAGE";

export const CART_GET = "CART/GET";
export const CART_GET_SUCCEEDED = "CART/GET_SUCCEEDED";
export const CART_GET_FAILED = "CART/GET_FAILED";

export const CART_EDIT = "CART/EDIT";
export const CART_EDIT_SUCCEEDED = "CART/EDIT_SUCCEEDED";
export const CART_EDIT_FAILED = "CART/EDIT_FAILED";

export const CART_CLEAR_LAST_ADDED = "CART/CLEAR_LAST_ADDED";
export const CART_CLEAR_CART = "CART/CLEAR_CART";
export const CART_ACK_REFRESH = "CART/ACK_REFRESH";